__turbopack_context__.v({
  "caption": "LightboxGallery-module__Jsed6a__caption",
  "closeBtn": "LightboxGallery-module__Jsed6a__closeBtn",
  "fullImage": "LightboxGallery-module__Jsed6a__fullImage",
  "grid": "LightboxGallery-module__Jsed6a__grid",
  "inline": "LightboxGallery-module__Jsed6a__inline",
  "nextBtn": "LightboxGallery-module__Jsed6a__nextBtn",
  "overlay": "LightboxGallery-module__Jsed6a__overlay",
  "prevBtn": "LightboxGallery-module__Jsed6a__prevBtn",
  "slick": "LightboxGallery-module__Jsed6a__slick",
  "thumb": "LightboxGallery-module__Jsed6a__thumb",
  "thumbButton": "LightboxGallery-module__Jsed6a__thumbButton",
  "wrapper": "LightboxGallery-module__Jsed6a__wrapper",
});
